/**
 * @generated SignedSource<<3183b9f7edc8dc7e87eb645832c05f79>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type trackingHelpers_rewards$data = {
  readonly currentProgram: {
    readonly programInfo: {
      readonly code: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "trackingHelpers_rewards";
};
export type trackingHelpers_rewards$key = {
  readonly " $data"?: trackingHelpers_rewards$data;
  readonly " $fragmentSpreads": FragmentRefs<"trackingHelpers_rewards">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "trackingHelpers_rewards"
};

(node as any).hash = "6974a50e60b803348cef6019717b8d97";

export default node;
